import Axios from "axios";
import {
    SET_INV_CUSTOMER_KPI_LIST,
    UNSET_INV_CUSTOMER_KPI_LIST,
  } from "@/store/mutation-types";
import { 
  getInvCustomerKpisList,
  saveInvCustomerKpi,
  updateInvCustomerKpi,
  getInvCustomerKpiById
} from "@/store/api";

const state = {
  getInvCustomerKpisList: [],
};

const getters = {
  getInvCustomerKpisList(state) {
    return state.getInvCustomerKpisList;
  },
};

const mutations = {
  [SET_INV_CUSTOMER_KPI_LIST](state, data) {
    state.getInvCustomerKpisList = data;
  },
  [UNSET_INV_CUSTOMER_KPI_LIST](state) {
    state.getInvCustomerKpisList = [];
  },
};

const actions = {

  saveInvCustomerKpi({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveInvCustomerKpi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  updateInvCustomerKpi({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    const invCustomerKpi = `${updateInvCustomerKpi}/${data.customer_kpi_id}`
    return new Promise((resolve, reject) => {
      Axios.put(invCustomerKpi, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getInvCustomerKpisList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvCustomerKpisList, {params:data})
        .then(function (response) {
          commit('SET_INV_CUSTOMER_KPI_LIST', response.data.data)
          resolve(response.data.data);
        })
        .catch(function (error) {
          commit('UNSET_INV_CUSTOMER_KPI_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInvCustomerKpiById({ commit }, data) {
    const getInvCustomerKpi = `${getInvCustomerKpiById}/${data}`;
    commit("SET_LOADING", {color: "primary"});  
    return new Promise((resolve, reject) => {
      Axios.get(getInvCustomerKpi)
        .then((response) => {
          resolve(response.data.code);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
